import PlayerManager from "../player-manager";
import RoomService from "../rooms-service";
import { updateQueueFromRoom } from "../utils";

const LOG = (...arg) => console.log("%%% SOCKET MANAGER %%% ", ...arg);

const handleRefresh = async (manager) => {
  const state = manager.state;
  const {
    room: { id },
  } = state;
  if (!id) return;
  const roomInfo = await RoomService.fetchRoom({ roomId: id });
  const { queue } = roomInfo;
  PlayerManager.updateQueue(queue);
  manager.refreshHandler();
};

const handleRemove = async (manager, ridx) => {
  PlayerManager.deleteFromQueue(ridx);
  // refresh, so that room gets updated with the queue
  manager.refreshHandler();
};

export default (manager) => {
  const socket = manager.socket;

  socket.on("reset", (data) => {
    LOG("resetting", data);
    PlayerManager.reset();
  });

  socket.on("play", (data) => {
    LOG("playing at ", data);
    const index = data;
    PlayerManager.playAtIdx(index);
  });

  socket.on("pause", (data) => {
    LOG("pausing", data);
    PlayerManager.pause();
  });

  socket.on("resume", (data) => {
    LOG("resuming", data);
    PlayerManager.resume();
  });

  socket.on("next", (data) => {
    LOG("next  ", data);
    PlayerManager.playNext();
  });

  socket.on("prev", (data) => {
    LOG("prev", data);
    PlayerManager.playPrev();
  });

  socket.on("seek", (data) => {
    LOG("resetting", data);
    const seekTo = data;
    PlayerManager.seek(seekTo);
  });

  socket.on("chat", (data) => {
    const { username, msg, roomId } = data;
    manager.chatHandler({ username, msg, roomId });
  });

  socket.on("refresh", () => {
    handleRefresh(manager);
  });

  socket.on("remove", (data) => {
    handleRemove(manager, data);
  });
};
